import { render, staticRenderFns } from "./applicationmaterials.vue?vue&type=template&id=557f397e&scoped=true&"
import script from "./applicationmaterials.vue?vue&type=script&lang=js&"
export * from "./applicationmaterials.vue?vue&type=script&lang=js&"
import style0 from "./applicationmaterials.vue?vue&type=style&index=0&id=557f397e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557f397e",
  null
  
)

export default component.exports